import HelpCards from "./components/HelpCards"
import HelpHero from "./components/HelpHero"
import HelpSupport from "./components/HelpSupport"
import { Form } from "../components"

export default function Help() {
  return (
    <>
      <section>
        <HelpHero />
        <HelpCards />
        <HelpSupport />

        <div className="bg-blue py-10 px-5 lg:py-20 2xl:px-0">
          <article className="xl:max-w-6xl xl:mx-auto">
            <h2 className="text-white text-3xl lg:text-5xl mb-5 lg:mb-10 lg:w-1/2 lg:leading-snug">
              Want to know more?{" "}
              <span className="block">Contact us today!</span>
            </h2>
            <Form />
          </article>
        </div>
      </section>
    </>
  )
}
